import { NoAuthGuard } from '../forgotpwd/no-auth-guard.service';
import { OtpComponent } from './otp.component'
import { NgModule } from '@angular/core';
import {AppRoutingModule} from '../app.routing'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
    imports: [
      AppRoutingModule,
      HttpClientModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ],
    declarations: [
        OtpComponent
    ],
  
    providers: [
      NoAuthGuard
    ]
  })
export class OtpModule {}